import React, { useState } from "react";
import ApiService from "../../../api/apiService";
import Swal from "sweetalert2";
import showSwal from "../../swal";
import "../../../styles/requests.css";
import "../../../styles/request-draft.css";

function RequestItemList({ requestData, onDraftDeleted = () => {} }) {
  const [isDeleting, setDeleting] = useState(false);

  console.log(
    "REQUEST ITEM DATA:",
    requestData,
  );

  const getUserId = () => {
    const storedUserDetails =
      localStorage.getItem("userDetails");

    if (!storedUserDetails) {
      return null;
    }

    try {
      const parsedUserDetails =
        JSON.parse(storedUserDetails);

      return parsedUserDetails?.id || null;
    } catch (error) {
      console.error(
        "Failed to parse userDetails:",
        error,
      );

      return null;
    }
  };

  const isDraft = requestData?.status === "Draft";

  const draftUrl =
    `/requests?p=new-request` +
    `&f=${encodeURIComponent(requestData?.form_id || "")}` +
    `&d=${encodeURIComponent(requestData?.id || "")}`;

  const handleDeleteDraft = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (isDeleting) return;

    const confirmation = await Swal.fire({
      title: "Delete this draft?",
      icon: "warning",
      text: "The draft and its attached files will be removed. This can't be undone.",
      showCancelButton: true,
      confirmButtonText: "Delete draft",
      cancelButtonText: "Keep it",
      confirmButtonColor: "#d33",
    });
    if (!confirmation?.isConfirmed) return;

    setDeleting(true);
    const response = await ApiService.forms.deleteDraft(requestData.id);
    setDeleting(false);

    if (!response?.success) {
      showSwal({
        title: "Draft not deleted",
        icon: "error",
        text: response?.message || "Please try again in a moment.",
        confirmButtonText: "OK",
      });
      return;
    }
    onDraftDeleted(requestData.id);
  };

  const detailUrl =
    `/requests?p=view-request-detail` +
    `&t=${encodeURIComponent(requestData?.request_type || "")}` +
    `&r=${encodeURIComponent(requestData?.id || "")}` +
    `&u=${encodeURIComponent(getUserId() || "")}` +
    `&r_url=${encodeURIComponent(window.location.href)}`;

  const rawRequestType =
    requestData?.request_type || "";

  const normalizedRequestType =
    rawRequestType.toUpperCase();

  const isCcar =
    normalizedRequestType === "CCAR";

  const isEpr =
    normalizedRequestType === "EPR";

  const requestType = isEpr
    ? "Request"
    : rawRequestType;

  const warehouse =
    requestData?.warehouse || "N/A";

  const customerAuditReferenceNumber =
    requestData?.reference_number || "N/A";

  const getStatusClass = () => {
    switch (requestData?.status) {
      case "Approved":
        return "approved";

      case "Denied":
        return "denied";

      case "Cancelled":
        return "cancelled";

      case "Draft":
        return "draft";

      default:
        return "pending";
    }
  };

  return (
    <a
      className="request-item--list-container"
      href={isDraft ? draftUrl : detailUrl}
    >
      <div className="request-item--row">
        <div className="request--item-logo">
          <i
            className="fa fa-file-text-o fa-4x"
            aria-hidden="true"
          ></i>
        </div>

        <div>
          <div className="request-ref-no">
            <h1>
              {requestData?.request_id ||
                "N/A"}
            </h1>
          </div>

          <div className="request--detail">
            <div className="request--detail-item">
              <span>
                Request Type:&nbsp;
              </span>

              <span>
                {requestType || "N/A"}
              </span>
            </div>

            <div className="request--detail-item">
              <span>
                Date &amp; Time Requested:&nbsp;
              </span>

              <span>
                {requestData?.date || "N/A"}
              </span>
            </div>

            {isCcar ? (
              <>
                <div className="request--detail-item">
                  <span>
                    Warehouse:&nbsp;
                  </span>

                  <span>{warehouse}</span>
                </div>

                <div className="request--detail-item">
                  <span>
                    Customer / Audit Reference
                    No.:&nbsp;
                  </span>

                  <span>
                    {
                      customerAuditReferenceNumber
                    }
                  </span>
                </div>
              </>
            ) : isEpr ? (
              <div className="request--detail-item">
                <span>
                  Total Cost:&nbsp;
                </span>

                <span>
                  {requestData?.total_cost ||
                    "₱0.00"}
                </span>
              </div>
            ) : null}
          </div>
        </div>
      </div>

      <div className="request--detail-status">
        <div
          className={`status ${getStatusClass()} request--item-approval-status`}
        >
          <span>
            {requestData?.status || "Pending"}
          </span>
        </div>

        {isDraft && (
          <button
            type="button"
            className="request-item__draft-delete"
            onClick={handleDeleteDraft}
            disabled={isDeleting}
          >
            {isDeleting ? "Deleting…" : "Delete draft"}
          </button>
        )}
      </div>
    </a>
  );
}

export default RequestItemList;